import { Loading, Notify, Report } from "notiflix"
import logo from '../assets/images/logos/logo_iica.svg'

export const loadingStart = () => {
    Loading.custom('Loading...', {
        customSvgUrl: logo,
        svgSize: '200px',
        cssAnimation: true,
    })
} 

export const loadingStop = () => {
    Loading.remove(500)
}

export const notifySuccess = (message:string) => {
    Notify.success(message)
}

export const notifyError = (message:string, title:string, button:string) => {
    Report.failure(title, message, button)
}